import React, { useState } from 'react';
import '../App.css'; 
import { useNavigate } from 'react-router-dom';
import { FaPlusCircle, FaPaperPlane } from 'react-icons/fa';
import { useBluetooth } from '../BluetoothContext'; 
import { Modal } from 'react-bootstrap'; 

const Selectchannels: React.FC = () => {
  const [channels, setChannels] = useState<string[]>(['']); 
  const [error, setError] = useState<string | null>(null); 
  const [popupVisible, setPopupVisible] = useState(false);
  const { configureChannels } = useBluetooth(); 
  const [isOverlayVisible, setIsOverlayVisible] = useState(false); 
  
  // Add a new input field
  const handleAddChannel = () => {
    if (channels.length < 10) {
      setChannels([...channels, '']); 
      setError(null); 
    } else {
      setError('Maximum limit of 10 input fields reached.');
    }
  };

  const handleInstructionClick = () => {
    setIsOverlayVisible(!isOverlayVisible);
  };

  // Update channel value
  const handleChannelChange = (index: number, value: string) => {
    const updatedChannels = [...channels];
    updatedChannels[index] = value;
    setChannels(updatedChannels);
  };

  // Submit the form
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const validChannels = channels.filter((channel) => channel.trim() !== ''); 
    if (validChannels.length > 0) {
      try {
        await configureChannels(validChannels); 
        console.log('Submitted Channels:', validChannels);
        setPopupVisible(true);
        setChannels(['']); 
        setError(null); 
      } catch (error) {
        console.error('Error configuring channels:', error);
      }
    } else {
      setError('Please fill in at least one channel.');
    }
  };

  const navigate = useNavigate();
  const handleReturnHome = () => {
    navigate('/');
  };

  return (
    <div className="selectchannels-background">
      <h1 className="h1">Select channels</h1>
      <span
        className="info-icon fs-3 ms-3"
        role="img"
        aria-label="info"
        onClick={handleInstructionClick}
        style={{ cursor: 'pointer', color: 'black' }}
      >
        ℹ️ Instructions
      </span>

      <form onSubmit={handleSubmit} className="selectchannels-horizontal-form">
        {channels.map((channel, index) => (
          <div key={index} className="channel-input-horizontal">
            <label htmlFor={`channel-${index}`} className="channel-label">
              {`Channel ${index + 1}`}
            </label>
            <input
              type="number"
              id={`channel-${index}`}
              value={channel}
              min={1}
              max={9999}
              placeholder={`Enter Channel`}
              onChange={(e) => handleChannelChange(index, e.target.value)}
              className="channel-input-field"
            />
          </div>
        ))}

        <div className="horizontal-button-container">
          <button
            type="button"
            id="addMoreChannels"
            onClick={handleAddChannel}
            className="custom-button-horizontal"
          >
            <FaPlusCircle className="button-icon" /> Add More Channels
          </button>

          <button type="submit" className="custom-button-horizontal submit-button">
            <FaPaperPlane className="button-icon" /> Submit
          </button>
        </div>
      </form>

      {popupVisible && (
        <div className="popup-container">
          <div className="popup-message">Channels configured successfully!</div>
          <button className="return-home-button" onClick={handleReturnHome}>
            Return Home
          </button>
        </div>
      )}

      {/* Instruction Overlay Modal */}
      <Modal show={isOverlayVisible} onHide={handleInstructionClick} centered>
        <Modal.Header closeButton>
          <Modal.Title>Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>This selects the <strong>channels</strong> your remote will cycle through.</p>
          <ol>
            <li>Enter a channel number in the <strong>Channel 1</strong> box.</li>
            <li>Press <strong>Add More Channels</strong> if you want to include more channels.</li>
            <li>Continue until all your preferred channels are entered.</li>
            <li>Press <strong>Submit</strong> to save.</li>
            <li>Your remote will now switch only between the channels you selected.</li>
          </ol>
        </Modal.Body>
      </Modal>

      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Selectchannels;
